import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency'
import { useVisibilityFormatter } from '@root/entities/preferences'
import { WalletAddressTruncated } from '@root/entities/wallet/ui/common/wallet-address-truncated'
import { AmountFormatted } from '@root/shared/core/format'

import type { WalletModel } from '@root/entities/wallet/atoms'

type Props = {
  wallet: WalletModel
}

export const WalletSummaryItem: React.FC<Props> = ({ wallet }) => {
  const nativeCurrency = CurrencyModel.nativeOf(wallet.network)
  const formatHidden = useVisibilityFormatter('****')
  const [totalBalanceNative] = useAtom(wallet.totalBalanceNative)
  const [name] = useAtom(wallet.name)
  const [color] = useAtom(wallet.color)

  const balanceFormatted = formatHidden(
    <AmountFormatted amount={totalBalanceNative} roundingMode="trunc" />,
  )

  const bulletStyle = {
    '--bullet-color': color,
  } as React.CSSProperties

  return (
    <PreviewRoot>
      <WalletBullet style={bulletStyle}></WalletBullet>
      <WalletLabel ellipsis>{name}</WalletLabel>
      <WalletAddress walletAddress={wallet.address} withCopy />
      <WalletBalance>
        {balanceFormatted}
        <span> {nativeCurrency.ticker}</span>
      </WalletBalance>
    </PreviewRoot>
  )
}

const WalletLabel = styled(Typography).attrs({
  variant: 'body4-semi-bold',
})``

const WalletAddress = styled(WalletAddressTruncated)`
  justify-content: center;
  gap: 2px;
  color: var(--text-8);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const WalletBalance = styled(Typography).attrs({
  variant: 'body4-bold',
  component: 'div',
})`
  text-align: right;
  white-space: nowrap;
`

const PreviewRoot = styled.div`
  display: grid;
  grid-template-columns: auto 1fr 1fr 1fr;
  gap: 6px;
  align-items: center;
`

const WalletBullet = styled.div`
  border-radius: 50%;
  width: 6px;
  height: 6px;
  background: var(--bullet-color);
`
